import { render } from "./BudgetTemplateCreate.vue?vue&type=template&id=5fd3840c&scoped=true"
import script from "./BudgetTemplateCreate.vue?vue&type=script&lang=js"
export * from "./BudgetTemplateCreate.vue?vue&type=script&lang=js"

import "./BudgetTemplateCreate.vue?vue&type=style&index=0&id=5fd3840c&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd3840c"]])

export default __exports__